module.exports = __webpack_public_path__ + "static/img/car_9_6_cold@3x.0a86e078.png";